// extracted by mini-css-extract-plugin
module.exports = {"webButton":"webButton_webButton__2LaL4","podText":"webButton_podText__3yWeA","webText":"webButton_webText__d28ut","podWebImage":"webButton_podWebImage__2EMW6"};